import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { PasswordResetService } from 'src/app/_services/password-reset.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['../login/login.component.css']
})
export class PasswordResetComponent implements OnInit {
  resetToken: string;
  isSubmitting: boolean = false;
  hideForm: boolean = false;
  isFirstLogin: boolean = false;
  resultMessageClass: string = "";
  resultMessage: string = "";
  passResetForm: UntypedFormGroup;
  passwordType: string = "password";
  passwordBtnTitle: string = "Reveal password";

  constructor(
    private titleService: Title,
    private passwordResetService: PasswordResetService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: UntypedFormBuilder
  ) {
    this.passResetForm = this.fb.group({
      password: ["", Validators.compose([this.passwordValidator.bind(this), Validators.required])],
      passwordConfirm: ["", Validators.required]
    })
  }

  ngOnInit(): void {
    this.titleService.setTitle('Password Reset - Productioneer Portal');

    this.route.queryParams.subscribe((params: Params) => {
      if (params['token']) {
        this.resetToken = params['token'];
        if (params['first'] && (params['first'] == 'true')) {
          this.isFirstLogin = true;
          this.resultMessageClass = "alert alert-info"
          this.resultMessage = "It appears this is your first time logging in. Please create a new password.";
        }
      }
      else {
        this.resultMessageClass = "alert alert-danger";
        this.resultMessage = "This password reset link is not valid. Please click on the link from your email or request a new link.";
        this.hideForm = true;
      }
    })

    this.passwordType = "password";
  }

  passwordValidator(control: any) {
    if (control.value) {
      const matches = control.value.match('(?=\S*)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}');
      return (matches && control.value.indexOf(" ") == -1) ? null : { 'invalidEmail': true };
    }

    return null;
  }

  onPasswordReset() {
    this.passwordType = "password";
    this.passwordBtnTitle = "Reveal password";
    this.isSubmitting = true;
    this.resultMessage = "";

    if (this.confirmPasswordsMatch()) {
      this.passwordResetService.updatePassword(this.passResetForm.value.password, this.resetToken).subscribe(
        result => {
          this.isSubmitting = false;
          this.resultMessageClass = "alert alert-success";
          this.resultMessage = "Your password was successfully reset. Click below to proceed to the login page.";
          this.hideForm = true;
        },
        err => {
          this.isSubmitting = false;
          this.resultMessageClass = "alert alert-danger";
          this.resultMessage = err.error || "Password reset failed. Please contact support if this continues to happen";
        });
    }
    else {
      this.isSubmitting = false;
    }
  }

  private confirmPasswordsMatch(): boolean {
    if (this.passResetForm.value.password == null || this.passResetForm.value.password == "") {
      this.resultMessageClass = "alert alert-danger";
      this.resultMessage = "Please enter your new password";
      return false;
    }
    if (this.passResetForm.value.password === this.passResetForm.value.passwordConfirm) {
      return true;
    }

    this.resultMessageClass = "alert alert-danger";
    this.resultMessage = "Please check that your passwords match and resubmit.";

    return false;
  }

  showPassword(obj: any) {
    if (this.passwordType == "password") {
      this.passwordType = "text";
      this.passwordBtnTitle = "Hide password";
    }
    else {
      this.passwordType = "password";
      this.passwordBtnTitle = "Reveal password";
    }
  }
}
